import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '@constants/common/environmentLinkEndpointNames';
import { HEADER_LINKS_TYPES } from '../constants/headerLinkTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';

export const minnesotaHeaderLogo = {
    link: true
};
export const minnesota = {
    linkDetails: [
        {
            name: 'dashboard',
            text: 'header.dashboard',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
            type: HEADER_LINKS_TYPES.LINK,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && !errorStatus
        },
        {
            name: 'manage_assister',
            text: 'header.manageAssister',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.MANAGE_ASSISTER,
            type: HEADER_LINKS_TYPES.LINK,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && environment.user && ALL_USER_ROLES.INDIVIDUAL === environment.user.role && !errorStatus
        },
        {
            name: 'assister_home',
            text: 'header.assisterHome',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.MANAGE_ASSISTER,
            type: HEADER_LINKS_TYPES.LINK,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && environment.user && ALL_USER_ROLES.EXTERNAL_ASSISTER === environment.user.role && !errorStatus
        },
        {
            name: 'learn_more',
            text: 'header.learnMore',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.HELP,
            type: HEADER_LINKS_TYPES.LINK
        },
        {
            name: 'get_help',
            text: 'header.getAssistance',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.HELP,
            type: HEADER_LINKS_TYPES.LINK
        },
        {
            name: 'login',
            text: 'header.login',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGIN,
            type: HEADER_LINKS_TYPES.LINK,
            visible: environment => environment.anonymous
        },
        {
            name: 'signout',
            text: 'header.logout',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGOUT,
            type: HEADER_LINKS_TYPES.LINK,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && !errorStatus,
            beforeClick: () => localStorage.clear()
        },
        {
            name: 'language',
            className: ['usa-nav__primary-item gi-main__nav__primary-item  link__language'],
            linkClassName:['gi-main__nav__primary-item__link'],
            text: 'header.lang',
            path: '#',
            type: HEADER_LINKS_TYPES.LANGUAGE_SWITCH
        }
    ]
};